import { render, staticRenderFns } from "./document-widget.vue?vue&type=template&id=08e37ea1&"
import script from "./document-widget.vue?vue&type=script&lang=js&"
export * from "./document-widget.vue?vue&type=script&lang=js&"
import style0 from "./document-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports